<template>
  <div
    class="dropdown"
    :class="{ 'is-active': isExpanded }"
    @keydown.esc="isExpanded = false"
  >
    <div class="dropdown-trigger">
      <button
        class="button is-small font-semibold whitespace-normal"
        :class="{ 'is-outlined is-success': type === 'scheduled' }"
        type="button"
        @click="isExpanded = !isExpanded"
      >
        <svg
          v-if="type === 'scheduled'"
          class="svg-inline--fa fa-w-14 mr-2"
          aria-hidden="true"
          role="img"
        >
          <use xlink:href="#icon-calendar-check"></use>
        </svg>
        <svg
          v-else-if="type === 'from' || type === 'unavailable'"
          class="svg-inline--fa fa-w-14 mr-2"
          aria-hidden="true"
          role="img"
        >
          <use xlink:href="#icon-reply"></use>
        </svg>
        <svg
          v-else-if="type === 'to'"
          class="svg-inline--fa fa-w-14 mr-2"
          aria-hidden="true"
          role="img"
        >
          <use xlink:href="#icon-hourglass"></use>
        </svg>

        {{
          meetingSuites[suiteId]
            ? getCompanySuiteName(
                meetingSuites[suiteId].name,
                meetingSuites[suiteId].company.name
              )
            : ''
        }}

        <svg
          v-if="type == 'scheduled' || isSuiteWriteable"
          class="svg-inline--fa fa-w-14 ml-2"
          aria-hidden="true"
          role="img"
        >
          <use xlink:href="#icon-angle-down"></use>
        </svg>
      </button>
    </div>
    <div v-if="isExpanded" class="dropdown-menu">
      <div
        class="dropdown-content"
        v-if="isSuiteWriteable || type === 'scheduled'"
      >
        <div class="dropdown-item is-size-7 has-text-centered">
          <b v-if="type === 'from'">Awaiting your response</b>
          <b v-else-if="type === 'scheduled'">Appointment is scheduled</b>
          <b v-else-if="type === 'to'">Waiting for approval</b>
          <b v-else-if="type === 'unavailable'"
            >Appointment no longer available</b
          >
        </div>
        <div class="dropdown-item" v-if="timeslot.is_open && type === 'from'">
          <button
            v-if="type === 'from'"
            type="button"
            class="button is-fullwidth is-small is-primary is-outlined"
            @click="approve"
          >
            <svg
              v-if="type === 'scheduled'"
              class="svg-inline--fa fa-w-14 mr-2"
              aria-hidden="true"
              role="img"
            >
              <use xlink:href="#icon-check-circle"></use>
            </svg>
            <span>Approve</span>
          </button>
        </div>
        <div class="dropdown-item" v-if="type === 'scheduled'">
          <button
            type="button"
            class="button is-fullwidth is-small is-info is-outlined"
            @click="showAddToCalendar = !showAddToCalendar"
          >
            <svg
              class="svg-inline--fa fa-w-14 mr-2"
              aria-hidden="true"
              role="img"
            >
              <use xlink:href="#icon-calendar-alt"></use>
            </svg>

            <div class="dropdown">
              <div class="dropdown-trigger">
                Add To Calendar
              </div>
              <div
                v-if="showAddToCalendar"
                class="dropdown-menu  calendar-actions"
              >
                <div class="dropdown-content">
                  <div class="dropdown-item">
                    <button
                      class="button is-fullwidth"
                      @click="
                        $emit('addToCalendar', 'ical');
                        isExpanded = !isExpanded;
                      "
                    >
                      <span class="icon is-small">
                        <i class="far fa-calendar"></i>
                      </span>
                      <span>iCalendar</span>
                    </button>
                  </div>
                  <div class="dropdown-item">
                    <button
                      class="button is-fullwidth"
                      @click="
                        $emit('addToCalendar', 'outlook');
                        isExpanded = !isExpanded;
                      "
                    >
                      <span class="icon is-small">
                        <i class="fab fa-microsoft"></i>
                      </span>
                      <span>Outlook</span>
                    </button>
                  </div>
                  <div class="dropdown-item">
                    <button
                      class="button is-fullwidth"
                      @click="
                        $emit('addToCalendar', 'google');
                        isExpanded = !isExpanded;
                      "
                    >
                      <span class="icon is-small">
                        <i class="fab fa-google"></i>
                      </span>
                      <span>Google</span>
                    </button>
                  </div>
                  <div class="dropdown-item">
                    <button
                      class="button is-fullwidth"
                      @click="
                        $emit('addToCalendar', 'yahoo');
                        isExpanded = !isExpanded;
                      "
                    >
                      <span class="icon is-small">
                        <i class="fab fa-yahoo"></i>
                      </span>
                      <span>Yahoo</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </button>
        </div>
        <div class="dropdown-item">
          <button
            v-if="type === 'from' || type === 'unavailable'"
            type="button"
            class="button is-fullwidth is-small is-danger is-outlined"
            @click="cancel"
          >
            <svg
              class="svg-inline--fa fa-w-14 mr-2"
              aria-hidden="true"
              role="img"
            >
              <use xlink:href="#icon-times-circle"></use>
            </svg>
            <span>Decline/Reschedule</span>
          </button>
          <button
            v-if="type === 'scheduled' && isSuiteWriteable"
            type="button"
            class="button is-fullwidth is-small is-danger is-outlined"
            @click="cancel"
          >
            <svg
              class="svg-inline--fa fa-w-14 mr-2"
              aria-hidden="true"
              role="img"
            >
              <use xlink:href="#icon-times-circle"></use>
            </svg>
            <span>Cancel/Reschedule</span>
          </button>
          <button
            v-if="type === 'to'"
            type="button"
            class="button is-fullwidth is-small is-primary is-outlined"
            @click="
              $router.push({
                name: 'ExhibitorSchedule',
                params: { id: meetingId, suiteId }
              })
            "
          >
            <svg
              class="svg-inline--fa fa-w-14 mr-2"
              aria-hidden="true"
              role="img"
            >
              <use xlink:href="#icon-arrow-right"></use>
            </svg>
            <span>Navigate to schedule</span>
          </button>
          <div class="control" v-if="type === 'scheduled' && user.isAdmin">
            <div class="label">Add Guest</div>
            <span v-if="!registrations.length"
              >Could not load meeting registrations. Your MatrixMaxx session may
              be expired. Please login and reload the page.</span
            >
            <template v-else>
              <multiselect
                :options="registrations"
                :searchable="true"
                label="display"
                track-by="id"
                placeholder="Start typing to search users"
                selectLabel=""
                @select="addGuest"
              >
              </multiselect>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { getCompanySuiteName } from '@/services/utils';
import Multiselect from 'vue-multiselect';

export default {
  props: {
    isSuiteWriteable: {
      type: Boolean,
      default: false
    },
    meetingId: {
      type: String,
      required: true
    },
    suiteId: {
      type: String,
      required: true
    },
    timeslot: {
      type: Object,
      required: true
    },
    type: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      isExpanded: false,
      showAddToCalendar: false
    };
  },

  computed: {
    ...mapGetters(['user', 'meetingSuites', 'registrations'])
  },

  methods: {
    getCompanySuiteName,
    approve() {
      this.$emit('approve');
    },
    cancel() {
      this.$emit('cancel');
    },
    addGuest(selectData) {
      this.isExpanded = false;
      this.$emit('addGuest', this.timeslot, selectData.id, selectData.display);
    }
  },
  components: {
    Multiselect
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/shared/AppointmentActions.vue